export const manifest = {
  screens: {
    scr_2ahenf: { name: "Landing Page", route: "/", position: {"x":160,"y":220} },
    scr_th80jq: { name: "Rental Shop", route: "/rental-shop", position: {"x":1560,"y":220} },
    scr_kvvgbf: { name: "Inspiration", route: "/inspiration", position: {"x":160,"y":4180} },
    scr_qzwj7d: { name: "Service", route: "/service", position: {"x":1560,"y":2200} },
    scr_lr3kut: { name: "About Us", route: "/about-us", position: {"x":160,"y":2200} },
    scr_f2ovv2: { name: "Contact", route: "/contact", position: {"x":2960,"y":2200} },
    scr_8ohae0: { name: "Shop Products", route: "/shop-products", position: {"x":2960,"y":220} },
  },
  sections: {
    sec_4dg38p: { name: "Shop & Browse", x: 0, y: 0, width: 4320, height: 1180 },
    sec_idl8xp: { name: "Company Information", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_qu5rvz: { name: "Inspiration & Content", x: 0, y: 3960, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_4dg38p", children: [
      { kind: "screen", id: "scr_2ahenf" },
      { kind: "screen", id: "scr_th80jq" },
      { kind: "screen", id: "scr_8ohae0" },
    ] },
    { kind: "section", id: "sec_idl8xp", children: [
      { kind: "screen", id: "scr_lr3kut" },
      { kind: "screen", id: "scr_qzwj7d" },
      { kind: "screen", id: "scr_f2ovv2" },
    ] },
    { kind: "section", id: "sec_qu5rvz", children: [
      { kind: "screen", id: "scr_kvvgbf" },
    ] },
  ],
}
